import {
  onSnapshot,
  firestoreDocumentById,
  firestoreDocumentsByQuery,
  getFieldValue,
  firestoreDocumentsBySubCollectionsQuery,
  createNewId,
  firestoreCollectionGroup,
  firestoreCollection,
  configureQuery,
  executeQuery,
  executeQueryRaw,
  removeDocumentInCollection,
  set as firestoreSet,
  setMerge as firestoreSetMerge,
  update as firestoreUpdate,
} from '@/shared/firebase/firestore';

export function getNewDocumentId() {
  return createNewId();
}

export function onSnapshotById(collection, id, callback, options = {}) {
  const query = firestoreDocumentById(collection, id);
  return onSnapshot(query, callback, options);
}

export function onSnapshotByQuery(collection, callback, criteria = [], orderBy, limit) {
  const query = firestoreDocumentsByQuery(collection, criteria, orderBy, limit);
  return onSnapshot(query, callback);
}

export function onSnapshotByQueryOnSubCollection(
  pathIds,
  pathCollections,
  subcollection,
  queryCriteria,
  callback,
  orderBy,
) {
  const query = firestoreDocumentsBySubCollectionsQuery(pathIds, pathCollections, subcollection, queryCriteria, orderBy);
  return onSnapshot(query, callback);
}

export async function findRawGroup(collection, queryCriteria = [], orderBy, limit) {
  let query = firestoreCollectionGroup(collection);
  query = configureQuery(query, queryCriteria, orderBy, limit);
  return executeQueryRaw(query);
}

export async function findRaw(collection, queryCriteria = [], orderBy, limit) {
  let query = firestoreCollection(collection);
  query = configureQuery(query, queryCriteria, orderBy, limit);
  return executeQueryRaw(query);
}

export async function find(collection, queryCriteria, orderBy, limit) {
  let query = firestoreCollection(collection);
  query = configureQuery(query, queryCriteria, orderBy, limit);
  return executeQuery(query);
}

export async function getById(collection, id) {
  const query = firestoreDocumentById(collection, id);
  return executeQuery(query);
}

export async function getRawById(collection, id) {
  const query = firestoreDocumentById(collection, id);
  return executeQueryRaw(query);
}

export async function fetchAll(collection) {
  const query = firestoreCollection(collection);
  const documents = await executeQueryRaw(query);
  return documents.docs;
}

export async function findInCollection(collection, queryCriteria, orderBy, limit) {
  return find(collection, queryCriteria, orderBy, limit);
}


export function getDocument(collection, id) {
  return getById(collection, id);
}

export const remove = (coll, id) => removeDocumentInCollection(coll, id);

export const set = async (coll, id, data, opts) => {
  const doc = firestoreDocumentById(coll, id);
  return firestoreSet(doc, data, opts);
};

export const setMerge = async (coll, id, data, opts) => {
  const doc = firestoreDocumentById(coll, id);
  return firestoreSetMerge(doc, data, opts);
};

export const update = async (coll, id, data, opts) => {
  const doc = firestoreDocumentById(coll, id);
  return firestoreUpdate(doc, data, opts);
};

export const addElementToArray = async (coll, id, field, newElement, undefinedSafe = true) =>
  update(coll, id, { [field]: getFieldValue().arrayUnion(newElement) }, { undefinedSafe });

export const removeElementToArray = async (coll, id, field, newElement, undefinedSafe = true) =>
  update(coll, id, { [field]: getFieldValue().arrayRemove(newElement) }, { undefinedSafe });
